// Persona landing pages (fear / analyst / simple) × (agencies / businesses).
// Prices mirror backend/routes/payments.py PACKAGES.

const IMG = "https://static.prod-images.emergentagent.com/jobs/b798ee84-c0e9-45cd-8132-8a7a658b0230/images/";

export const AGENCY_PACKAGES = [
  {
    id: "agency_start", name: "Start", price: 99, clients: 5,
    bullets: [
      "Do 5 klientov v jednom paneli",
      "Reporty s vaším logom (PDF + zdieľaný odkaz)",
      "AI viditeľnosť v 6 AI vyhľadávačoch",
      "30 % partnerská provízia",
    ],
  },
  {
    id: "agency_growth", name: "Growth", price: 249, clients: 15, recommended: true,
    bullets: [
      "Do 15 klientov v jednom paneli",
      "Všetko zo Start",
      "Hromadné skeny klientov cez CSV",
      "AI odporúčania úprav pre každého klienta",
    ],
  },
  {
    id: "agency_scale", name: "Scale", price: 599, clients: 50,
    bullets: [
      "Do 50 klientov v jednom paneli",
      "Všetko z Growth",
      "API prístup + WordPress plugin",
      "Prioritná podpora",
    ],
  },
];

export const BUSINESS_PACKAGES = [
  {
    id: "pro_monthly", name: "Pro", price: 49, recommended: true,
    bullets: [
      "Neobmedzené AI audity vášho webu",
      "Sledovanie 6 AI vyhľadávačov",
      "Týždenný report do emailu",
      "Konkrétny zoznam úprav",
    ],
  },
  {
    id: "business_monthly", name: "Business", price: 169,
    bullets: [
      "Všetko z Pro + viac domén",
      "Sledovanie až 10 konkurentov",
      "Vlastné otázky pre AI monitoring",
      "Onboarding hovor + prioritná podpora",
    ],
  },
  {
    id: "enterprise_monthly", name: "Enterprise", price: 399,
    bullets: [
      "Všetko z Business bez limitov",
      "SLA a dedikovaný manažér",
      "White-label exporty reportov",
      "Vlastné integrácie",
    ],
  },
];

const AGENCY_STEPS = [
  { title: "Pridáte klientov", text: "Ručne alebo naraz cez CSV. Stačí doména a názov firmy." },
  { title: "AI skontroluje viditeľnosť", text: "Zistíme, či klienta spomína ChatGPT, Perplexity, Gemini, Claude, Copilot a Google AI." },
  { title: "Pošlete report pod vlastnou značkou", text: "PDF alebo zdieľaný odkaz s vaším logom a farbami. Naša značka tam nie je." },
];

const BUSINESS_STEPS = [
  { title: "Zadáte svoj web", text: "Bez registrácie a bez inštalácie." },
  { title: "Zistíme, čo o vás hovorí AI", text: "Pozrieme sa do 6 AI vyhľadávačov a porovnáme vás s konkurenciou." },
  { title: "Dostanete zoznam krokov", text: "Presne, čo opraviť, aby vás AI začala odporúčať. Každý týždeň vidíte pokrok." },
];

const AGENCY_FAQ = [
  { q: "Uvidia klienti, že používame TopRankPulse?", a: "Nie. Reporty aj zdieľané odkazy nesú vaše logo a farby." },
  { q: "Ako funguje partnerská provízia?", a: "Za každého klienta, ktorý si u nás cez váš odkaz kúpi vlastný plán, dostávate 30 % z každej jeho platby, kým platí." },
  { q: "Môžem balík kedykoľvek zmeniť alebo zrušiť?", a: "Áno. Platba je mesačná, zrušíte ju jedným klikom a prístup vám ostane do konca zaplateného obdobia." },
  { q: "Koľko si môžem účtovať klientovi?", a: "Cenu určujete vy. Agentúry bežne predávajú AEO/GEO reporting ako samostatnú mesačnú službu." },
];

const BUSINESS_FAQ = [
  { q: "Potrebujem na to technické znalosti?", a: "Nie. Report je písaný ľudskou rečou a ku každej úprave je jasný postup." },
  { q: "Je audit naozaj zadarmo?", a: "Áno, prvý AI audit je zadarmo. Platíte až za pravidelné sledovanie a reporty." },
  { q: "Môžem predplatné zrušiť?", a: "Kedykoľvek, jedným klikom. Prístup vám ostane do konca zaplateného obdobia." },
];

export const PERSONA_PAGES = {
  agentury: {
    obava: {
      seoTitle: "AI vyhľadávanie pre agentúry – nestraťte klientov | TopRankPulse",
      seoDesc: "Vaši klienti sa pýtajú na AI vyhľadávanie. Ponúknite im AEO a GEO reporty pod vlastnou značkou skôr, než to urobí iná agentúra.",
      badge: "Pre digitálne a SEO agentúry",
      headline: "Vaši klienti sa už pýtajú na AI vyhľadávanie.",
      highlight: "Ak im odpoveď nedáte vy, dá im ju iná agentúra.",
      sub: "ChatGPT, Perplexity a Google AI odporúčajú firmy bez kliknutia na web. Klient, ktorý tam nie je, to skôr či neskôr zistí a začne sa pýtať, za čo vám platí.",
      image: IMG + "30ba8be86c642510ca671a81068d6d910c78a28dbd34a158c84f4c70610c9b7d.jpeg",
      triad: {
        fear: { title: "Čo sa stane, ak budete čakať", points: [
          "Klient si v ChatGPT nájde konkurenta namiesto seba a príde s otázkou, na ktorú nemáte report.",
          "Iná agentúra mu ponúkne „AI viditeľnosť“ ako novú službu a s ňou si vezme aj jeho SEO rozpočet.",
          "Klasický SEO report ukazuje pozície v Google, ale nie to, či vás AI vôbec spomenie.",
        ] },
        hope: { title: "Čo získate, keď začnete dnes", points: [
          "Každému klientovi ukážete, ako ho vidí 6 AI vyhľadávačov, skôr než sa spýta.",
          "Pridáte novú mesačnú službu bez nového zamestnanca.",
          "Reporty idú pod vaším logom, takže zásluhy aj vzťah s klientom ostávajú u vás.",
        ] },
        must: { title: "Bez toho to dnes nejde", rows: [
          ["Prehľad AI viditeľnosti klienta", "Nevidíte ho", "6 AI vyhľadávačov v jednom reporte"],
          ["Report pre klienta", "Ručne v Exceli", "Hotové PDF s vaším logom"],
          ["Návrhy úprav", "Hádate", "AI odporúčania pre každého klienta"],
          ["Nová služba v ponuke", "Nemáte ju", "Spustíte ešte dnes"],
        ] },
      },
      finalHeadline: "Buďte agentúra, ktorá s AI vyhľadávaním prišla prvá",
      finalSub: "Growth balík: do 15 klientov, white-label reporty a 30 % partnerská provízia.",
    },
    analytik: {
      seoTitle: "AEO a GEO ako mesačná služba agentúry – marža a čísla | TopRankPulse",
      seoDesc: "Fixná cena za balík, 6 AI vyhľadávačov, white-label reporty. Pri balíku Growth vás jeden klient stojí €16,60 mesačne.",
      badge: "Pre agentúry, ktoré rozhodujú podľa čísel",
      headline: "AEO a GEO ako mesačná služba.",
      highlight: "Prepočítajte si maržu skôr, než to urobí konkurencia.",
      sub: "Jeden nástroj, všetci klienti, 6 AI vyhľadávačov a reporty pod vašou značkou. Pri balíku Growth vás jeden klient stojí €16,60 mesačne.",
      image: IMG + "5f1158183e4a4559476ccc999aa14404aab8a44066fd42c131afe826986bc70c.jpeg",
      triad: {
        fear: { title: "Riziko, ktoré sa dá spočítať", points: [
          "Časť dopytov sa presúva z vyhľadávača do AI asistentov. Tie neukazujú 10 odkazov, ale 1 až 3 odporúčania.",
          "Ak AI viditeľnosť nemeriate, nemôžete ju klientovi vyúčtovať ani obhájiť.",
          "Kto si meranie postaví sám, platí za API, vývoj a údržbu skôr, než zarobí prvé euro.",
        ] },
        hope: { title: "Čo dostanete", points: [
          "Fixnú cenu za balík, takže náklad na klienta poznáte vopred.",
          "Merateľné výstupy: skóre citácií, podiel zmienok oproti konkurencii a vývoj v čase.",
          "30 % doživotnú províziu z každého klienta, ktorého privediete na vlastný plán.",
        ] },
        must: { title: "Porovnanie: vlastné riešenie vs. TopRankPulse", rows: [
          ["Náklad na klienta", "Neznámy (API + vývoj)", "€11,98 – €19,80 mesačne"],
          ["Meranie", "Jednorazové testy", "Pravidelné AI kontroly pre 6 AI vyhľadávačov"],
          ["Škálovanie", "Rastie s počtom ľudí", "Do 50 klientov v jednom paneli"],
          ["Reporting", "Manuálny", "White-label PDF + zdieľaný odkaz"],
        ] },
      },
      finalHeadline: "Čísla sedia. Začnite s balíkom Growth.",
      finalSub: "€249 mesačne za 15 klientov. Zrušiteľné kedykoľvek.",
    },
    jednoducho: {
      seoTitle: "Nová služba pre klientov agentúry – AI vyhľadávanie | TopRankPulse",
      seoDesc: "Pridajte klienta, zistite ako ho vidia AI vyhľadávače a pošlite mu report s vaším logom. Bez učenia a bez programovania.",
      badge: "Pre agentúry a freelancerov",
      headline: "Nová služba pre vašich klientov.",
      highlight: "Bez učenia, bez programovania.",
      sub: "Pridáte klienta, systém zistí, ako ho vidia AI vyhľadávače, a vy mu pošlete prehľadný report s vaším logom. Hotovo.",
      image: IMG + "d61d75e8baa8fa6ed6b9ccc20332528b93b253caa24bd62c85c91c9a8d886100.jpeg",
      triad: {
        fear: { title: "Prečo to riešiť práve teraz", points: [
          "Ľudia sa čoraz častejšie pýtajú ChatGPT namiesto Googlu.",
          "Vaši klienti to vidia tiež a budú chcieť vedieť, či ich AI odporúča.",
          "Kto im to ukáže prvý, ten si klienta udrží.",
        ] },
        hope: { title: "Čo z toho máte vy", points: [
          "Novú službu, ktorú môžete predávať každý mesiac.",
          "Spokojnejších klientov, lebo výsledky vidia čierne na bielom.",
          "Ďalší príjem z 30 % partnerskej provízie.",
        ] },
        must: { title: "Pred a po", rows: [
          ["Klient sa spýta na AI", "Neviete, čo povedať", "Pošlete mu report"],
          ["Report", "Hodiny práce", "Pár minút, s vaším logom"],
          ["Všetci klienti", "Rozhádzaní v tabuľkách", "Na jednom mieste"],
          ["Príjem", "Rovnaký ako vlani", "Nová mesačná služba + provízia"],
        ] },
      },
      finalHeadline: "Začnite ešte dnes",
      finalSub: "Growth balík: do 15 klientov a reporty pod vlastnou značkou.",
    },
  },
  firmy: {
    obava: {
      seoTitle: "Odporúča ChatGPT vašu firmu alebo konkurenciu? | TopRankPulse",
      seoDesc: "AI asistenti odpovedajú pár menami. Zistite, či medzi nimi ste, a čo urobiť, aby vás AI začala odporúčať.",
      badge: "Pre firmy a e-shopy",
      headline: "Keď sa zákazník spýta ChatGPT na najlepšiu firmu vo vašom odbore…",
      highlight: "odporučí vás, alebo konkurenciu?",
      sub: "AI asistenti odpovedajú jednou vetou a pár menami. Ak tam nie ste, zákazník o vás ani nevie a vy neviete, že ste ho stratili.",
      image: IMG + "619950780272330f8011c6f37cec020d732977f73291b6550568592a66f28884.jpeg",
      triad: {
        fear: { title: "Čo sa deje, keď to nesledujete", points: [
          "Zákazník dostane odporúčanie na konkurenta a na váš web už nepríde.",
          "V Google Analytics to neuvidíte, lebo ku kliku vôbec nedôjde.",
          "Konkurent, ktorý to rieši, si buduje náskok, ktorý sa ťažko dobieha.",
        ] },
        hope: { title: "Čo sa zmení, keď to začnete riešiť", points: [
          "Uvidíte, či vás spomína ChatGPT, Perplexity, Gemini, Claude, Copilot aj Google AI.",
          "Dostanete presný zoznam, čo opraviť, aby vás AI začala odporúčať.",
          "Každý týždeň report, takže viete, či sa to zlepšuje.",
        ] },
        must: { title: "Bez toho to dnes nejde", rows: [
          ["Viete, či vás AI odporúča?", "Nie", "Áno, v 6 AI vyhľadávačoch"],
          ["Čo opraviť", "Netušíte", "Konkrétny zoznam krokov"],
          ["Sledovanie zmien", "Žiadne", "Týždenný report"],
          ["Cena", "Agentúra: stovky € mesačne", "od €49 mesačne"],
        ] },
      },
      finalHeadline: "Nedovoľte, aby AI posielala zákazníkov konkurencii",
      finalSub: "Pro: sledovanie 6 AI vyhľadávačov a týždenný report za €49 mesačne.",
    },
    analytik: {
      seoTitle: "Meranie AI viditeľnosti firmy – dáta, nie dojmy | TopRankPulse",
      seoDesc: "Pravidelné AI kontroly pre 6 AI vyhľadávačov, podiel zmienok oproti konkurencii a technické odporúčania pre schema, entity a obsah.",
      badge: "Pre marketing a vedenie firmy",
      headline: "Merajte AI viditeľnosť ako každý iný kanál.",
      highlight: "Dáta, nie dojmy.",
      sub: "Pravidelné AI kontroly pre 6 AI vyhľadávačov, podiel zmienok oproti konkurencii a konkrétne technické odporúčania (schema, entity, obsah).",
      image: IMG + "88952985b7c71c18d45e17fe6570dce3d94be2955b608c714a64ceedb86bdffb.jpeg",
      triad: {
        fear: { title: "Prečo jednorazový test nestačí", points: [
          "To, čo sa nemeria, sa nedá riadiť ani obhájiť pred vedením.",
          "Odpovede AI sa líšia a menia v čase, takže jeden test v ChatGPT nič nepovie.",
          "Bez porovnania s konkurenciou neviete, či ste na tom dobre alebo zle.",
        ] },
        hope: { title: "Čo budete merať", points: [
          "Podiel zmienok vašej značky oproti konkurentom v každom AI vyhľadávači.",
          "Vývoj v čase a dopad každej úpravy, ktorú urobíte.",
          "Technický stav: schema, entity, štruktúra obsahu a čitateľnosť pre AI.",
        ] },
        must: { title: "Jednorazový test vs. pravidelné meranie", rows: [
          ["Počet AI vyhľadávačov", "1", "6"],
          ["Frekvencia", "Raz", "Priebežne + týždenný report"],
          ["Konkurencia", "Bez porovnania", "Podiel zmienok vs. konkurenti"],
          ["Výstup", "Dojem", "Dáta a zoznam krokov"],
        ] },
      },
      finalHeadline: "Začnite merať ešte dnes",
      finalSub: "Pro za €49 mesačne. Zrušiteľné kedykoľvek.",
    },
    jednoducho: {
      seoTitle: "Odporúča vás umelá inteligencia? Zistite to zadarmo | TopRankPulse",
      seoDesc: "Zadajte web a zistite, čo o vás hovorí ChatGPT a ďalšie AI. Ak vás nespomínajú, povieme vám po ľudsky, čo s tým urobiť.",
      badge: "Pre živnostníkov a malé firmy",
      headline: "Zistite, či vás odporúča umelá inteligencia.",
      highlight: "Za 2 minúty, zadarmo.",
      sub: "Zadáte web, my zistíme, čo o vás hovorí ChatGPT a ďalšie AI. Ak vás nespomínajú, povieme vám po ľudsky, čo s tým urobiť.",
      image: IMG + "f914c55b83be1cc1a770c9b8e6f251daf656dfdf08ef9ee308fc9fb46f54bd4b.jpeg",
      triad: {
        fear: { title: "Prečo na tom záleží", points: [
          "Ľudia sa už nepýtajú len Googlu, ale aj ChatGPT.",
          "AI odporučí pár firiem a ostatné ani nespomenie.",
          "Ak nie ste medzi nimi, zákazníci idú inam.",
        ] },
        hope: { title: "Čo dostanete", points: [
          "Jasnú odpoveď: odporúča vás AI, alebo nie.",
          "Jednoduchý zoznam, čo zlepšiť.",
          "Týždenný report, aby ste videli, že to funguje.",
        ] },
        must: { title: "Pred a po", rows: [
          ["Odporúča vás AI?", "Neviete", "Viete to čierne na bielom"],
          ["Čo s tým", "Netušíte", "Krok za krokom"],
          ["Čas", "Hodiny hľadania", "2 minúty"],
          ["Cena", "Drahá agentúra", "Audit zadarmo, potom od €49 mesačne"],
        ] },
      },
      finalHeadline: "Nech vás AI začne odporúčať",
      finalSub: "Pro za €49 mesačne: sledovanie, report a zoznam úprav.",
    },
  },
};

export const AUDIENCES = {
  agentury: { label: "agentúry", packages: AGENCY_PACKAGES, featured: "agency_growth", steps: AGENCY_STEPS, faq: AGENCY_FAQ },
  firmy: { label: "firmy", packages: BUSINESS_PACKAGES, featured: "pro_monthly", steps: BUSINESS_STEPS, faq: BUSINESS_FAQ },
};

export const PERSONA_LABELS = { obava: "Obava", analytik: "Analytik", jednoducho: "Bežný človek" };

const adUrl = (aud, persona) =>
  `/pre-${aud}/${persona}?utm_source=facebook&utm_medium=paid_social&utm_campaign=${aud}_${persona}`;

export const PERSONA_ADS = [
  {
    id: "agentury_obava", audience: "agentury", persona: "obava",
    primaryText: "Vaši klienti sa už pýtajú, prečo ich ChatGPT neodporúča. Ak im odpoveď nedáte vy, dá im ju iná agentúra. Ponúknite AEO a GEO reporty pod vlastnou značkou ešte tento týždeň.",
    headline: "Nestraťte klientov kvôli AI vyhľadávaniu",
    description: "White-label reporty · do 15 klientov · €249/mes",
    cta: "Zistiť viac",
  },
  {
    id: "agentury_analytik", audience: "agentury", persona: "analytik",
    primaryText: "AEO a GEO ako mesačná služba: 6 AI vyhľadávačov, jeden panel, reporty s vaším logom. Pri balíku Growth vás klient stojí €16,60 mesačne. Cenu pre klienta určujete vy, plus 30 % doživotná provízia.",
    headline: "Klient za €16,60 mesačne. Marža je na vás.",
    description: "Fixná cena · merateľné výstupy · 30 % provízia",
    cta: "Prepočítať maržu",
  },
  {
    id: "agentury_jednoducho", audience: "agentury", persona: "jednoducho",
    primaryText: "Nová služba pre vašich klientov bez učenia a programovania. Pridáte klienta, systém zistí, ako ho vidí ChatGPT a ďalšie AI, a vy pošlete report s vaším logom.",
    headline: "Nová mesačná služba pre vašu agentúru",
    description: "Reporty pod vašou značkou · od €99/mes",
    cta: "Zistiť viac",
  },
  {
    id: "firmy_obava", audience: "firmy", persona: "obava",
    primaryText: "Keď sa zákazník spýta ChatGPT na najlepšiu firmu vo vašom odbore, odporučí vás, alebo konkurenciu? V Google Analytics to neuvidíte, lebo ku kliku nedôjde. Zistite to skôr, než stratíte ďalších zákazníkov.",
    headline: "Odporúča ChatGPT vás, alebo konkurenciu?",
    description: "AI audit zadarmo · 6 AI vyhľadávačov",
    cta: "Zistiť viac",
  },
  {
    id: "firmy_analytik", audience: "firmy", persona: "analytik",
    primaryText: "Merajte AI viditeľnosť ako každý iný kanál: podiel zmienok oproti konkurencii v 6 AI vyhľadávačoch, vývoj v čase a technické odporúčania pre schema, entity a obsah.",
    headline: "AI viditeľnosť: dáta, nie dojmy",
    description: "Pravidelné kontroly · týždenný report · €49/mes",
    cta: "Zistiť viac",
  },
  {
    id: "firmy_jednoducho", audience: "firmy", persona: "jednoducho",
    primaryText: "Odporúča vás umelá inteligencia? Zadajte web a za 2 minúty to zistíte, zadarmo. Ak vás nespomína, povieme vám po ľudsky, čo s tým urobiť.",
    headline: "Zistite za 2 minúty, či vás AI odporúča",
    description: "Zadarmo · bez registrácie",
    cta: "Vyskúšať",
  },
].map((ad) => ({ ...ad, image: PERSONA_PAGES[ad.audience][ad.persona].image, url: adUrl(ad.audience, ad.persona) }));
